const prefixName = '@dashboard/';

export const HAS_ERROR = `${prefixName}has_error`;
export const IS_LOADING = `${prefixName}is_loading`;
export const SET_LAST_UPDATE = `${prefixName}set_last_update`;
export const READ = `${prefixName}read`;
